/**
 * Repository Copy Fragment - ES6 Module Version
 * Handles copy form submission state (disable buttons, change button text)
 */

let initialized = false;

// ============================================================================
// Repository Copy Handlers
// ============================================================================

const RepositoryCopyHandlers = {
    /**
     * Handle copy form before request - disable buttons and change copy button text
     */
    onCopyFormBeforeRequest(e, element) {
        const copyButton = document.getElementById('copy-button');
        const cancelButton = document.getElementById('cancel-button');

        if (copyButton) {
            copyButton.dataset.originalText = copyButton.textContent;
            copyButton.textContent = 'Copying...';
            copyButton.disabled = true;
            copyButton.style.opacity = '0.5';
        }
        if (cancelButton) {
            cancelButton.disabled = true;
            cancelButton.style.opacity = '0.5';
        }
    },

    /**
     * Handle copy form after request - reset buttons state
     */
    onCopyFormAfterRequest(e, element) {
        const copyButton = document.getElementById('copy-button');
        const cancelButton = document.getElementById('cancel-button');

        if (copyButton) {
            copyButton.textContent = copyButton.dataset.originalText || 'Copy';
            copyButton.disabled = false;
            copyButton.style.opacity = '';
        }
        if (cancelButton) {
            cancelButton.disabled = false;
            cancelButton.style.opacity = '';
        }
    }
};

/**
 * Initialize repository copy fragment
 * Called from main.js on DOMContentLoaded
 */
export function initRepositoryCopy() {
    if (initialized) return;
    initialized = true;

    // Listen for HTMX beforeRequest on copy forms
    document.addEventListener('htmx:beforeRequest', (event) => {
        if (event.target.id === 'copy-form') {
            RepositoryCopyHandlers.onCopyFormBeforeRequest(event, event.target);
        }
    });

    // Listen for HTMX afterRequest on copy forms to reset button state
    document.addEventListener('htmx:afterRequest', (event) => {
        if (event.target.id === 'copy-form') {
            RepositoryCopyHandlers.onCopyFormAfterRequest(event, event.target);
        }
    });
}
